import * as TY from 'containers/pages/customers/constants';
import validateEmail from 'libs/validations/validateEmail';
import { CustomerValidation, FieldValidation } from 'containers/pages/customers/types';

type SetValidFn = (fn: (prev: CustomerValidation) => CustomerValidation) => void;

function handleCustomer(
  e: { target: { name: string; value: string } },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: (action: { type: string; payload: any }) => void,
  setValid: SetValidFn,
) {
  const name = e.target.name.trim();
  const value = e.target.value;

  switch (name) {
    case TY.NAME:
      dispatch({ type: TY.NAME, payload: value });
      setValid((prev) => ({
        ...prev,
        Name: {
          isErr: !value.trim(),
          errMsg: !value.trim() ? 'Customer name is required' : '',
          canNotSave: !value.trim(),
        },
      }));
      break;

    case TY.ADDRESS:
      dispatch({ type: TY.ADDRESS, payload: value });
      break;

    case TY.WORK_PHONE:
      dispatch({ type: TY.WORK_PHONE, payload: value });
      break;

    case TY.CELL_PHONE:
      dispatch({ type: TY.CELL_PHONE, payload: value });
      break;

    case TY.HOME_PHONE:
      dispatch({ type: TY.HOME_PHONE, payload: value });
      break;

    case TY.WORK_EMAIL: {
      const result = validateEmail(value) as { isErr: boolean; errMsg: string };
      setValid((prev) => ({
        ...prev,
        WorkEmail: {
          isErr: result.isErr,
          errMsg: result.errMsg,
          canNotSave: result.isErr,
        },
      }));
      dispatch({ type: TY.WORK_EMAIL, payload: value });
      break;
    }

    case TY.PERSONAL_EMAIL: {
      const result = validateEmail(value) as { isErr: boolean; errMsg: string };
      setValid((prev) => ({
        ...prev,
        PersonalEmail: {
          isErr: result.isErr,
          errMsg: result.errMsg,
          canNotSave: result.isErr,
        },
      }));
      dispatch({ type: TY.PERSONAL_EMAIL, payload: value });
      break;
    }

    case TY.OTHER_EMAIL: {
      const result = validateEmail(value) as { isErr: boolean; errMsg: string };
      setValid((prev) => ({
        ...prev,
        OtherEmail: {
          isErr: result.isErr,
          errMsg: result.errMsg,
          canNotSave: result.isErr,
        },
      }));
      dispatch({ type: TY.OTHER_EMAIL, payload: value });
      break;
    }

    default:
      dispatch({ type: name, payload: value });
      break;
  }
}

export default handleCustomer;
